<div class="footer-background">
  <div class="footer-container-rounded">

    <div class="upper-footer">
      <div class="address-container">
        <span>C. Fray Luis de Palacio 377, Ladrón de Guevara, Ladron De Guevara, 44650 Guadalajara, Jal.</span>
      </div>

      <div class="footer-main-logos">
        <div class="footer-logos">
          <span style="white-space: nowrap;">Supervisada por:</span>
          <div style="display: flex; flex-direction: row; align-items: center; gap: 16px;">
            <img src="{{ icons.logoCondusef }}" alt="Condusef"
                style="cursor:pointer;">
            <img src="{{ icons.logoBanxico }}" alt="Banxico"
                style="cursor:pointer;">
          </div>
        </div>

        <div class="footer-logos">
          <span style="white-space: nowrap;">Registrada ante:</span>
          <img src="{{ icons.logoBuro }}" alt="Buró"
              style="cursor:pointer;">
        </div>
      </div>

      <div class="last-reels-social">
        <button class="facebook"
          (mouseenter)="facebookHovered = true"
          (mouseleave)="facebookHovered = false"
          (click)="openFacebook()">
          <img [src]="facebookHovered ? 'assets/icons/facebook-white.svg' : 'assets/icons/facebook-grey.svg'" alt="Facebook DRAM">
          <span>Facebook DRAM</span>
        </button>

        <button class="instagram"
          (mouseenter)="instagramHovered = true"
          (mouseleave)="instagramHovered = false"
          (click)="openInstagram()">
          <span>Instagram DRAM</span>
          <img [src]="instagramHovered ? 'assets/icons/instagram-white.svg' : 'assets/icons/instagram-grey.svg'" alt="Instagram DRAM">
        </button>
      </div>
    </div>

    <div class="footer-divider"></div>

    <div class="middle-footer">
      <span>D. R. 2025 Todos los Derechos Reservados Dram Capital S.A.P.I. de C.V.,SOFOM, E.N.R.</span>
      <a [routerLink]="['/terminos-condiciones']" target="_blank" rel="noopener noreferrer">Términos y condiciones</a>
      <a [routerLink]="['/aviso-privacidad']" target="_blank" rel="noopener noreferrer">Aviso de privacidad</a>
    </div>

    <div class="footer-divider"></div>

    <div class="bottom-footer">
      <p>DRAM CAPITAL, Bajo el carácter de Sociedad Financiera de Objeto Múltiple, Entidad no Regulada,
        para su constitución y operación no requiere autorización de la secretaría de Hacienda y Crédito
        Público, y está sujeta a la supervisión y vigilancia de la Comisión Nacional Bancaria y de Valores
        únicamente para efectos de lo dispuesto por el artículo 56 de la ley general de organizaciones y
        Actividades Auxiliares del Crédito.
      </p>
      <!-- <p>DRAM CAPITAL, S.O.F.O.M., Institución de financiera  en términos de la Ley
        para Regular las Instituciones de Tecnología Financiera, es una sociedad autorizada,
        regulada y supervisada por las autoridades financieras. Número de autorización:
        <span>P00000</span>
      </p>
      <br>
      <p>Ni el Gobierno Federal ni las entidades de la administración pública paraestatal
        podrán responsabilizarse o garantizar los recursos de los clientes que sean
        utilizados en las operaciones que celebren con las ITF o frente a otros, así
        como tampoco asumir alguna responsabilidad por las obligaciones contraídas por
        las ITF o por algún cliente frente a otro, en virtud de las operaciones que celebren.
        Los retornos, rendimientos o tasas de interés son estimadas, por lo que no se asegura
        el resultado o éxito de las inversiones.
      </p>
      <br>
      <p>Tasa de interés anual y fija de 8.9% a 38.9% sin IVA, sujeta a evaluación y calificación
        de nuestra área de crédito. Ejemplo representativo: monto de crédito por $400,000.00,
        con tasa anual de 18.9% y a un plazo de 36 meses. Monto total a pagar: $537,882.91 sin IVA.
        Sujeto a aprobación de préstamo. CAT PROMEDIO: 26.7% sin IVA. Fecha de cálculo
        15 de diciembre 2024. Calculado para fines informativos y de comparación exclusivamente.
      </p>
      <br>
      <p>Círculo Inteligente, S.A.PI. de C.V. SOFOM E.N.R., bajo el carácter de Sociedad Financiera
        de Objeto Múltiple, Entidad no Regulada, para su constitución y operación no requiere
        autorización de la Secretaría de Hacienda y Crédito Público, y está sujeta a la supervisión
        y vigilancia de la Comisión Nacional Bancaria y de Valores únicamente para efectos de lo
        dispuesto por el artículo 56 de la Ley General de Organizaciones y Actividades Auxiliares del Crédito.
      </p>
      <br>
      <p>Nuestros préstamos son otorgados en moneda nacional (pesos mexicanos). Asimismo,
        nuestros productos y servicios se encuentran disponibles exclusivamente en México.
      </p> -->
    </div>

  </div>
</div>
